import { toast } from "react-toastify"
import { AppCommType } from "../models/api/AppCommType"
import { IMChat } from "../models/api/IMChat"
import { Pages } from "../models/constants"
import { rootStore } from "../StApp"
import Logger from "./Logger"
import NotificationService from "./NotificationService"

class NotificationHandlerSevice {


    constructor() {
        navigator.serviceWorker.register('/firebase-messaging-sw.js')
    }

    handleImChat(msg: IMChat) {

        Logger.debug(rootStore.uiStore.currentPath, "Current_Path")

        if (rootStore.mainStore.appFocus) {

            if (rootStore.uiStore.currentPath == Pages.IM_CHATS)
                return

            if (rootStore.uiStore.currentPath == Pages.IM_CHATBOX) {
                if (rootStore.mainStore.currentImChatMeta?.uid == msg.senderUid)
                    return

            }

            this.launchToast(`${msg.senderId} has sent a message`)

        }
        else
            this.launchNotif('New Message', `${msg.senderId} has sent a message`)

    }

    handleAppComm(commType: AppCommType) {

        switch (commType) {
            case AppCommType.NEW_MATCH: this.launchToast('You have a new match :D')
                break;

            case AppCommType.POT_MATCH: this.launchToast('You have a potential match ;)')
                break;

            case AppCommType.SAY_HELLO: this.launchToast('Someone says hello :)')
                break;
        }

    }

    private launchNotif(tag: string, body: string) {

        try {

            if (NotificationService.getNotificationPermission()) {
                //new Notification("New Message", { body: `${msg.senderId} has sent a message` })
                Logger.debug('Showing Notification')
                navigator.serviceWorker.ready.then(function (registration) {
                    registration.showNotification(tag, {
                        body: body,
                        vibrate: [400, 100, 400],
                        tag: tag,
                        icon: "/sc_applogo_mic.jpg",
                        badge: '/sc_applogo_mic_badge.jpg'
                    });
                });
            }

        } catch (error) {
            Logger.err(error)
        }
    }

    private launchToast(body: string) {
        toast(body, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
        });
        navigator.vibrate([200, 100, 200])
    }
}

export default new NotificationHandlerSevice()